<template>
    <div class="pagination-container">
      <ul class="pagination">
        <!-- Previous Button -->
        <li
          :class="{ disabled: currentPage === 1 }"
          @click="changePage(currentPage - 1)"
          class="page-item"
        >
          <a class="page-link" href="#" @click.prevent>Previous</a>
        </li>
  
        <!-- Page 1 -->
        <li
          :class="{ active: currentPage === 1 }"
          @click="changePage(1)"
          class="page-item"
        >
          <a class="page-link" href="#" @click.prevent>1</a>
        </li>
  
        <!-- Left Ellipsis -->
        <li v-if="showLeftEllipsis" class="page-item ellipsis">
          <span class="page-link">...</span>
        </li>
  
        <!-- Page Numbers in Between -->
        <li
          v-for="page in pagesInBetween"
          :key="page"
          :class="{ active: page === currentPage }"
          @click="changePage(page)"
          class="page-item"
        >
          <a class="page-link" href="#" @click.prevent>{{ page }}</a>
        </li>
  
        <!-- Right Ellipsis -->
        <li v-if="showRightEllipsis" class="page-item ellipsis">
          <span class="page-link">...</span>
        </li>
  
        <!-- Last Page -->
        <li
          v-if="totalPages > 1"
          :class="{ active: currentPage === totalPages }"
          @click="changePage(totalPages)"
          class="page-item"
        >
          <a class="page-link" href="#" @click.prevent>{{ totalPages }}</a>
        </li>
  
        <!-- Next Button -->
        <li
          :class="{ disabled: currentPage === totalPages }"
          @click="changePage(currentPage + 1)"
          class="page-item"
        >
          <a class="page-link" href="#" @click.prevent>Next</a>
        </li>
      </ul>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      totalPages: {
        type: Number,
        required: true,
      },
      currentPage: {
        type: Number,
        required: true,
      },
    },
    computed: {
      pagesInBetween() {
        if (this.totalPages <= 5) {
          return Array.from({ length: this.totalPages - 2 }, (_, i) => i + 2);
        }
  
        const start = Math.max(2, this.currentPage - 1);
        const end = Math.min(this.totalPages - 1, this.currentPage + 1);
  
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
      },
      showLeftEllipsis() {
        return this.currentPage > 3;
      },
      showRightEllipsis() {
        return this.currentPage < this.totalPages - 2;
      },
    },
    methods: {
      changePage(page) {
        if (page > 0 && page <= this.totalPages) {
          this.$emit('page-changed', page);
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  
  .pagination {
    list-style-type: none;
    padding: 0;
    display: flex;
  }
  
  .page-item {
    margin: 0 5px;
    cursor: pointer;
  }
  
  .page-item.disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
  
  .page-item.active .page-link {
    font-weight: bold;
    text-decoration: underline;
  }
  
  .ellipsis {
    cursor: default;
  }
  </style>
  